module.exports = __webpack_public_path__ + "img/338.449e497.png";